export default "__VITE_ASSET__BO585Hw8__"